import { jsx as _jsx } from "react/jsx-runtime";
import { Link, LinkTarget, LinkRelEnum, IconName } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
import { FALLBACK_LANG, getProductManualDocument } from '../../../util/ManualUtil';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
const DownloadManualSection = ({ productManual, manualBaseUrl, lang, filteredProductManualKeys, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    return (_jsx(Link, { emphasize: true, dataQA: "product_manual", href: manualBaseUrl + getProductManualDocument(filteredProductManualKeys, lang, productManual, FALLBACK_LANG), iconStart: IconName.DOWNLOAD, target: LinkTarget.BLANK, rel: LinkRelEnum.NOOPENER, children: t('pdp.manual.download') }));
};
export default DownloadManualSection;
